import React from 'react'
import { useSelector } from 'react-redux';
interface Props {
  subjectLine1: string
  cardPreviewHeader: string
  cardPreviewFooter?: string
  isCta: boolean
  ctaText: string
  ctaLink: string
}
const ViewCardPreview: React.FC<Props> = ({ subjectLine1, cardPreviewHeader, cardPreviewFooter, isCta, ctaText, ctaLink }) => {
  const currentWorkspace = useSelector((state: any) => state.currentWorkspace);
  const card = useSelector((state: any) => state.card);

  // Get colors from card data or use defaults
  const primaryColor = card?.currentCardData?.emailPreviewData?.primaryColor || '#86efac'; // green-300
  const secondaryColor = card?.currentCardData?.emailPreviewData?.secondaryColor || '#60a5fa'; // blue-400

  // Create gradient style
  const gradientStyle = {
    background: `linear-gradient(to bottom right, ${primaryColor}, ${secondaryColor})`
  };

  return (
    <div className='px-7 py-5 flex justify-center items-center min-h-[500px]' style={gradientStyle}>
      <div className='bg-white shadow-2xl rounded-2xl w-full max-w-md overflow-y-auto max-h-[80vh] transform transition-all duration-300'>
        <div className='p-8'>
          <div className='flex justify-between items-center mb-6'>
            <div>
              <img className="h-12 object-contain" src={currentWorkspace?.previewSetting ? currentWorkspace?.previewSetting?.companyLogo : 'https://res.cloudinary.com/interstellus/image/upload/v1675421128/Cardclan-Logo-final_t6l4ie.png'} alt='companylogo' />
            </div>
          </div>
          <div className='text-center mb-6'>
            <h2 className='text-xl font-bold text-gray-900'>
              {cardPreviewHeader ? cardPreviewHeader : subjectLine1}
            </h2>
          </div>
          <div className='flex justify-center mb-6'>
            <img className='w-full rounded-xl shadow-lg object-cover' src={card?.currentCardData?.designUrl} alt='designImage' />
          </div>
          {cardPreviewFooter && (
            <div className='text-center mb-4'>
              <p className='text-sm text-gray-600'>{cardPreviewFooter}</p>
            </div>
          )}
          <div className={isCta ? 'flex justify-center mt-6' : 'hidden'}>
            <a href={`https://${ctaLink}`} target="_blank" className='px-8 py-3 text-white rounded-full font-semibold shadow-lg transition duration-300 ease-in-out transform hover:scale-105' style={{ backgroundColor: primaryColor }} rel="noreferrer">
              {ctaText}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewCardPreview